import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

export default function PageTracker() {
  const loc = useLocation();
  useEffect(() => {
    const path = loc.pathname;
    if (path.startsWith("/admin") || path.startsWith("/login") || path.startsWith("/register")) return;
    const params = new URLSearchParams(loc.search);
    const ref = params.get("ref") || localStorage.getItem("sv_ref") || "";
    let referrer_host = "";
    try {
      if (document.referrer) referrer_host = new URL(document.referrer).hostname;
    } catch (e) { referrer_host = ""; }
    if (referrer_host === window.location.hostname) referrer_host = "";
    const product_slug = path.startsWith("/product/") ? decodeURIComponent(path.split("/product/")[1] || "") : "";
    api.post("/track/view", { path, product_slug, ref, referrer_host }).catch(() => {});
  }, [loc.pathname]); // eslint-disable-line
  return null;
}
